import React from 'react';

import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import ApiKeysContainer from '../../ApiKeysContainer';
import KeysListTableRow from './KeysListTableRow';

const StyledFirstTableCell = styled(TableCell)`
    width: 80%;
`;

const KeysListTable: React.FC = () => {
    const { apiKeys } = useContainer(ApiKeysContainer);
    const { t } = useTranslation('admin_settings');

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <StyledFirstTableCell>{t('api-keys.name')}</StyledFirstTableCell>
                    <TableCell>{t('api-keys.expiration-date')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {apiKeys.map((apiKey, index) => <KeysListTableRow apiKey={apiKey} key={index}></KeysListTableRow>)}
            </TableBody>
        </Table>
    );
};

export default KeysListTable;
